/* From https://dev.to/djchadderton/making-tinymce-work-with-rails-turbolinks-and-stimulus-2ooa */
import { Controller } from "@hotwired/stimulus"

// Import TinyMCE
import tinymce from 'tinymce/tinymce';

/* Omdat er ook een aantal basis scripts geladen moeten worden, voeg EVT de volgende regel toe:
 * Rails.application.config.assets.paths << Rails.root.join("node_modules/tinymce")
*/

// Import icons
import 'tinymce/icons/default';

// Import theme
import 'tinymce/themes/silver/theme';

// Import skin: see application.scss
// import 'tinymce/skins/ui/oxide/skin.min.css';

import 'tinymce/models/dom';

/* Import plugins */
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/code';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';

import 'tinymce/plugins/image';
import 'tinymce/plugins/media';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/importcss';
import 'tinymce/plugins/fullscreen';

export default class extends Controller {
  // Targets zijn een beetje overbodig. We kunnen gewoon met selector uit de voeten.
  static targets = ['content_input', 'media_input']

  initialize () {

    // Basis configuratie
    let base_config= {
      license_key: 'gpl', 
      skin: false,
      plugins: ['importcss', 'image', 'media', 'link', 'anchor', 'lists', 'code', 'charmap', 'fullscreen', 'table'],
      menubar: false,
      toolbar: 'undo redo | pastetext | blocks | bold italic superscript | image media| anchor link | numlist bullist | alignleft aligncenter alignright | charmap code | table fullscreen',
      contextmenu: 'link image removeformat',

      // Image plugin    
      images_upload_url: '/content/content_assets/upload',
      image_caption: true,
      image_list: '/content/content_assets/tinymce_image_list?type[]=ContentPage&type[]=ContentPageTranslation&type[]=none',

      // Link plugin
      link_list: '/content/content_pages/tinymce_link_list',
      link_class_list: [
        {title: 'Geen', value: ''},
        {title: 'Permanente Link', value: 'pid'}
      ],

      language: 'nl',
      language_url: RAILS_ASSET_URL('/tinymce/langs/nl.js'),
      content_css: RAILS_ASSET_URL('/tinymce_content.css'),

      // Video
      media_dimensions: false,
      media_poster: false,

      branding: false,
      toolbar_sticky: true,
      statusbar: true, 

      paste_as_text: true,
      relative_urls: false,

      block_formats: 'Paragraph=p;Heading 2=h2;Heading 3=h3;Heading 4=h4;Heading 5=h5',

      formats: {
        // Changes the alignment buttons to add a class to each of the matching selector elements
        alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img,audio,video', classes: 'align-left' },
        aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img,audio,video', classes: 'align-center' },
        alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img,audio,video', classes: 'align-right' },
        alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img,audio,video', classes: 'align-justify' }
      }

      /* Use style_formats with styles toolbar option, but does not work well? */
      // style_formats: [
      //   {title: 'Headings', items: [
      //     {title: 'Heading 2', format: 'h2'}, 
      //     {title: 'Heading 3', format: 'h3'}, 
      //     {title: 'Heading 4', format: 'h4'}, 
      //     {title: 'Heading 5', format: 'h5'}
      //     ]}, 
      //   {title: 'Inline', items: [
      //     {title: 'Bold', format: 'bold'}, 
      //     {title: 'Italic', format: 'italic' }, 
      //     {title: 'Strikethrough', format: 'strikethrough' }, 
      //     {title: 'Superscript', format: 'superscript' }, 
      //     {title: 'Subscript', format: 'subscript' }
      //     ]},
      //   {title: 'Blocks', items: [
      //     { title: 'Paragraph', format: 'p' }, 
      //     { title: 'Blockquote', format: 'blockquote' }, 
      //     { title: 'Pre', format: 'pre' }, 
      //     { title: 'Introtext', block: 'header', classes: ['intro-text'] }
      //     ]} 
      //   ]
    }


    // Default main Editor
    this.main_content_config= Object.assign({}, base_config);   // Clone base_config

    // Image and Media Editor
    this.media_content_config= Object.assign({}, base_config);   // Clone base_config
    this.media_content_config.toolbar= 'undo redo | blocks | bold italic superscript | blockquote bullist | image | link anchor | charmap code | fullscreen';

    // Simple Editor for basic text fields
    this.simple_content_config= Object.assign({}, base_config);   // Clone base_config
    this.simple_content_config.toolbar= 'undo redo | blocks | bold italic superscript | blockquote bullist | image | link anchor | charmap code | fullscreen';

    // Mini editor for captions etc
    this.mini_content_config= Object.assign({}, base_config);   // Clone base_config
    this.mini_content_config.statusbar= false;
    this.mini_content_config.toolbar= 'undo redo | bold italic superscript | link code fullscreen';
    this.mini_content_config.contextmenu= 'link removeformat';

  }

  connect () {
    const img_upload_url= this.element.dataset.imagesUploadUrl;
    const img_list_url= this.element.dataset.imageListUrl;
    const link_list_url= this.element.dataset.linkListUrl;

    try {
      if( img_upload_url) this.main_content_config['images_upload_url']= img_upload_url;
      if( img_list_url) this.main_content_config['image_list']= img_list_url;
      if( link_list_url) this.main_content_config['link_list']= link_list_url;

      let main_config = Object.assign({ target: this.content_inputTarget }, this.main_content_config)
      tinymce.init(main_config)
    } catch (error) {
      // Input target not defined?
      // console.error(error);
    }

    try {
      if (this.media_inputTarget) {
        if( img_upload_url) this.media_content_config['images_upload_url']= img_upload_url;      
        if( img_list_url) this.media_content_config['image_list']= img_list_url;
        if( link_list_url) this.media_content_config['link_list']= link_list_url;

        // We can override the urls with the editor element itself
        if (this.media_inputTarget.dataset.imagesUploadUrl) {
          this.media_content_config['images_upload_url']= this.media_inputTarget.dataset.imagesUploadUrl;
          console.log(this.media_content_config['images_upload_url']);
        }
        if (this.media_inputTarget.dataset.imageListUrl) {
          this.media_content_config['image_list']= this.media_inputTarget.dataset.imageListUrl;
        }
        if (this.media_inputTarget.dataset.linkListUrl) {
          this.media_content_config['link_list']= this.media_inputTarget.dataset.linkListUrl;
        }
      }

      let media_config = Object.assign({ target: this.media_inputTarget }, this.media_content_config)
      tinymce.init(media_config)
    } catch (error) {
      // Input target not defined?
      // console.error(error);
    }

    try {
      if( img_upload_url) this.simple_content_config['images_upload_url']= img_upload_url;
      if( img_list_url) this.simple_content_config['image_list']= img_list_url;
      if( link_list_url) this.simple_content_config['link_list']= link_list_url;

      let simple_config = Object.assign({selector: 'textarea.tinymce.simple'}, this.simple_content_config)

      tinymce.init(simple_config)
    } catch (error) {
      // Input target not defined?
      console.error(error);
    }

    try {
      let mini_config = Object.assign({selector: 'textarea.tinymce.mini', height: 200}, this.mini_content_config)
      tinymce.init(mini_config)
    } catch (error) {
      // Input target not defined?
      // console.error(error);
    }

  }

  disconnect () {
    tinymce.remove()
  }
}
